import { Component } from '@angular/core';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { Paginator } from '../../../../models/Paginator';
import { Company } from '../../../../models/Company';
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { RouterLink } from '@angular/router';
import { GenericCrudComponent } from '../../../../shared/components/generic-crud/generic-crud.component';
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-company-configuration',
  standalone: true,
  imports: [
    RouterLink,
    GenericCrudComponent
  ],
  templateUrl: './company-configuration.component.html',
  styleUrl: './company-configuration.component.css'
})
export class CompanyConfigurationComponent {
  tableColums: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
    { name: 'NIF', active: true, type: 'text', key: 'nif', sort: false },
    { name: 'Tipo', active: true, type: 'text', key: 'type', sort: false },
    { name: 'Direccion', active: true, type: 'text', key: 'address', sort: false },
    { name: 'Teléfono', active: true, type: 'text', key: 'phone', sort: false },
    { name: 'Email', active: true, type: 'text', key: 'email', sort: false },
    { name: 'Observaciones', active: false, type: 'text', key: 'observations', sort: false },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
    { name: 'Fecha Modificación', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
  ];

  formFields: GenericFormField[] = [
    { name: 'companyName', type: 'text', label: 'Nombre de la empresa', validations: 'required', testValue: 'Sociedad 1' },
    { name: 'nif', type: 'text', label: 'NIF de la empresa', validations: 'required', testValue: 'B12348613' },
    { name: 'type', type: 'select', label: 'Tipo', validations: 'nullable', optionsList: [{ id: 'Sociedad Propia', name: 'Sociedad Propia' }, { id: 'Sociedad Centro Oficial', name: 'Sociedad Centro Oficial' }], singleSelection: true },
    { name: 'address', type: 'text', label: 'Dirección', colspan: 2, testValue: 'Direccion de prueba 66, Cox, 03350, Alicante' },
    { name: 'phone', type: 'text', label: 'Teléfono', validations: 'required', testValue: '660066006' },
    { name: 'email', type: 'text', label: 'Email', validations: 'required', testValue: 'test@test.com' },
    { name: 'observations', type: 'textarea', label: 'Observaciones', colspan: 2, testValue: 'Observaciones de prueba de la sociedad 1' },
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'companyName', type: 'text', label: 'Nombre de la empresa', validations: 'required', testValue: 'Empresa 1' },
    { name: 'nif', type: 'text', label: 'NIF de la empresa', validations: 'required', testValue: 'B1234567' },
    { name: 'address', type: 'text', label: 'Dirección', colspan: 2 },
    { name: 'phone', type: 'text', label: 'Teléfono', validations: 'required', testValue: '660066006' },
    { name: 'email', type: 'text', label: 'Email', validations: 'required', testValue: 'test@test.com' },
    { name: 'observations', type: 'textarea', label: 'Observaciones', colspan: 2 },
  ];


  form: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'sociedad',
    createButtonTitle: 'Nueva Sociedad',
    cols: 2,
    createApiSlug: '/config/company/store',
    formTitle: 'Crear Sociedad',
    formButtonTitle: 'Crear Sociedad',
    width: '4xl'
  }

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      // actionSlug: '/config/office/update/{{id}}',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'sociedad',
        createButtonTitle: '',
        cols: 2,
        originalUpdateApiSlug: '/config/company/update/{{id}}',
        createApiSlug: '',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{name}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        width: '4xl'
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-dark"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" /><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" /><path d="M16 5l3 3" /></svg>',
      confirmation: false,

    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-primary"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿Desea eliminar la sociedad?',
      deleteRowOnResponse: true,
      actionSlug: '/config/company/delete/{{id}}',
    }
  ]

  table: GenericTable<Paginator<Company>> = {
    columns: this.tableColums,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/company/list',
    paginate: true,
    name: 'sociedad',
    actions: this.tableActions
  };

  filters: Filter[] = [
    { type: 'search', key: 'name|nif', operator: 'like', placeholder: 'Nombre o NIF' },
    { type: 'multiselect', key: 'type.name', operator: 'in', placeholder: 'Tipo', optionsList: [{ id: 'Sociedad Propia', name: 'Sociedad Propia' }, { id: 'Sociedad Centro Oficial', name: 'Sociedad Centro Oficial' }], relation_filter_column: 'type' },
    { type: 'date-between', key: 'created_at', operator: 'between', parsed: "date-arr", placeholder: 'Fecha de creación' },
  ];

  genericCRUD: GenericCRUD<Paginator<Company>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: false
  }
}
